import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=da141bfa&scoped=true&"
import script from "./Register.vue?vue&type=script&lang=js&"
export * from "./Register.vue?vue&type=script&lang=js&"
import style0 from "@/assets/scss/mobile/authenticate/_register.scss?vue&type=style&index=0&id=da141bfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da141bfa",
  null
  
)

export default component.exports